module.exports = __webpack_public_path__ + "static/media/mon-sat_and_everyday_digital_cropped.ca6d0ca5.webp";